import Course from "./course.model";
import Quiz from "./quiz.model";

export default class IPagination {
  pageIndex: number;
  pageSize: number;
  count: number;
  data: any[];
}

export class SpecParams {
  sort = "";
  pageNumber = 1;
  pageSize = 50;
  search: string;
  tag?: string;
  uid?: string;
}

export class CourseSpecParams {
  sort = "";
  pageNumber = 1;
  pageSize = 10;
  search: string;
  tag?: string;
  uid?: string;
}

export class PaginationCourse implements IPagination {
  pageIndex: number;
  pageSize: number;
  count: number;
  data: Course[] = [];
}

export class PaginationQuiz implements IPagination {
  pageIndex: number;
  pageSize: number;
  count: number;
  data: Quiz[] = [];
}

export class WhereList {
  fieldPath: string;
  value: any;
}

export class CustomParams {
  id?: string;
  accessToken?: string;
}
